<template>
    <ul class="list-inline">
        <li>
            <router-link to="/stages">All</router-link>
        </li>
        <li>
            <router-link to="/stages/Art">Art</router-link>
        </li>
        <li>
            <router-link to="/stages/Dance">Dance</router-link>
        </li>
        <li>
            <router-link to="/stages/Music">Music</router-link>
        </li>
        <li>
            <router-link to="/stages/Other">Other</router-link>
        </li>
    </ul>
</template>

<script>
    export default {
        name: 'StageFilter',
        data () {
            return {
                msg: 'Welcome to Your Vue.js App'
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/include/StageFilter.vue